export default __webpack_public_path__ + "static/media/announcement_4@2x.97ff61bf.png";